import { DialogUtility } from '@syncfusion/ej2-popups';
const grid = {
    pageSettings: { pageSizes: [10, 20, 50, 100], pageSize: 50, pageCount: 4 },
    filterSettings: {
        type: 'Menu',
        operators: {
            stringOperator: [
                { value: "startswith", text: "Starts With" },
                { value: "endswith", text: "Ends With" },
                { value: "contains", text: "Contains" },
                { value: "equal", text: "Equal" },
            ],
            numberOperator: [
                { value: "equal", text: "Equal" },
                { value: "notequal", text: "Not Equal" },
                { value: "lessthan", text: "Less Than" },
                { value: "lessthanorequal", text: "Less Than or Equal" },
                { value: "greaterthan", text: "Greater Than" },
                { value: "greaterthanorequal", text: "Greater Than or Equal" },
            ],
            dateOperator: [
                { value: "equal", text: "Equal" },
                { value: "notequal", text: "Not Equal" },
                { value: "lessthan", text: "Less Than" },
                { value: "lessthanorequal", text: "Less Than or Equal" },
                { value: "greaterthan", text: "Greater Than" },
                { value: "greaterthanorequal", text: "Greater Than or Equal" },
            ],
        },
    },
    actionBegin: function (args, refs) { //
        // Helper: resolve the ej2 Grid instance from refs or the event args
        const resolveGridInstance = () => {
            if (refs) {
                const gridKey = Object.keys(refs).find(key => key.startsWith('grid') && refs[key]);
                if (gridKey && refs[gridKey].ej2Instances) return refs[gridKey].ej2Instances;
                if (refs.grid && refs.grid.ej2Instances) return refs.grid.ej2Instances;
                if (gridKey && refs[gridKey]) return refs[gridKey];
            }
            // fallback to the sender on the event (ej2 Grid instance)
            if (args && args.sender) return args.sender;
            return null;
        };

        const gridInstance = resolveGridInstance();

        if (args.requestType == "filtering") {
            if (args.currentFilterObject && typeof args.currentFilterObject.value.getMonth === 'function') {
                var selectedDate = args.currentFilterObject.value;
                var specificOffset = selectedDate.getTimezoneOffset();

                // update query params if we have a grid instance with a Query object
                if (gridInstance && gridInstance.query && gridInstance.query.params) {
                    gridInstance.query.params = gridInstance.query.params.filter(p => p.key !== "timezoneOffset");
                    gridInstance.query.addParams("timezoneOffset", specificOffset);
                }

                var dateNew = new Date(args.currentFilterObject.value);
                dateNew.setHours(dateNew.getHours() - (dateNew.getTimezoneOffset() / 60));
                args.currentFilterObject.value = dateNew;
            }

        }

        if (args.requestType == "save") {
            for (var propt in args.data) {
                if (args.data[propt] && typeof args.data[propt].getMonth === 'function') {
                    var dateNew = new Date(args.data[propt]);
                    dateNew.setHours(dateNew.getHours() - (dateNew.getTimezoneOffset() / 60));
                    args.data[propt] = dateNew;
                }
            }
        }
    },
    actionComplete: function (args, refs) {
        if (args.columnType === "string") {
            args.filterModel.flMuiObj.dropOptr.value = "contains";
        }
        if ((args.requestType === 'beginEdit' || args.requestType === 'add')) {
            let dialog = args.dialog;
            dialog.zIndex = 1100;
            dialog.header = args.requestType === 'beginEdit' ? "Edit details" : 'Add new record';
        }
        if ((args.requestType === 'save')) {
            let gridKey = Object.keys(refs).find(key => key.startsWith('grid') && refs[key]);
            if (gridKey) {
                refs[gridKey].refresh();
            }

        }
        if (args.requestType === 'delete') {
            let gridKey = Object.keys(refs).find(key => key.startsWith('grid') && refs[key]);
            let message = { title: 'Success!', content: 'Record is deleted successfully', cssClass: 'e-toast-success' };
            refs[gridKey].$root.$emit('showToast', message);
        }
    },
    errorAlert: function (text) { this.dialogAalert(text, 'Error', 'errorAlert') },
    warningAlert: function (text) { this.dialogAalert(text, 'Error', 'warningAlert') },
    infoAlert: function (text) { this.dialogAalert(text, 'Info', 'infoAlert') },
    dialogAalert: function (text, title, cssClass) {
        DialogUtility.alert({
            title: title,
            content: text,
            position: { X: 700, Y: 200 },
            showCloseIcon: true,
            closeOnEscape: true,
            animationSettings: { effect: 'Zoom' },
            zIndex: 1100,
            cssClass: cssClass
        });
    },
    async actionFailure(args) {
        try {
            if (args[0]) {
                const response = await args[0].error[0].error.text();
                if (response.split("\"errors\":")[1]) {
                    this.errorAlert(response.split("\"errors\":")[1]);
                } else {
                    this.errorAlert(JSON.parse(response).message);
                }
            }
            else {
                const response = await args.error[0].error.text();
                if (response.split("\"errors\":")[1]) {
                    this.errorAlert(response.split("\"errors\":")[1]);
                } else {
                    this.errorAlert(JSON.parse(response).message);
                }
            }
        } catch (error) {
            this.errorAlert("Unexpected error:", error);
        }
    },
    excelExport: function (args, name, refs) {
        if (args.item.id.includes('excelexport')) {
            let excelExportProperties = {
                fileName: name,
                theme:
                {
                    header: {
                        fontName: 'Arial', fontColor: '#001c55'
                    },
                    record: {
                        fontName: 'Arial', fontColor: '#4d4d4d'
                    },
                    caption: {
                        fontName: 'Arial', fontColor: '#4d4d4d'
                    }
                }
            };

            //after changes with grid name, it is no longer default name 'grid' it is dynamic 
            let gridKey = Object.keys(refs).find(key => key.startsWith('grid') && refs[key]);
            if (gridKey) {
                refs[gridKey].showSpinner();
                refs[gridKey].excelExport(excelExportProperties);
            }

        }
    },

}

export default grid;